import axios from 'axios';
import { setAlert } from './alert';
import setAuthToken from '../utils/setAuthToken'

import {
    GET_MEMBERSHIPS,
    GET_MEMBERSHIP,
    CREATE_MEMBERSHIP,
    UPDATE_MEMBERSHIP,
    DELETE_MEMBERSHIP,
} from './types';

const API_URL = process.env.REACT_APP_SERVER_API_URL;

// Get all memberships
export const getMemberships = () => async dispatch => {
    if( localStorage.token ){
        setAuthToken( localStorage.token )
    }
    
    try {
        const res = await axios.get(`${API_URL}/membership/all`);

        if(res.data.success){
            dispatch({
                type : GET_MEMBERSHIPS,
                payload: res.data.data
            });
            dispatch( setAlert('Successfully fetched memberships', 'success') );
        }else{
            dispatch( setAlert(res.data.error, 'danger') );
        }
    } catch (err) {
        dispatch(setAlert('Failed to fetch memberships', 'danger'));
    }
}

// Get a single membership
export const getMembership = id => async dispatch => {
    if( localStorage.token ){
        setAuthToken( localStorage.token )
    }
    try {
        const res = await axios.get(`${API_URL}/membership/${id}`);
  
        if(res.data.success){  
            dispatch({
                type : GET_MEMBERSHIP,
                payload: res.data.data
            });
            dispatch( setAlert('Successfully fetched membership details', 'success') );
        }else{
            dispatch( setAlert(res.data.error, 'danger') );
        }
    } catch (err) {
        dispatch(setAlert('Error: Failed to get membership details', 'danger'));
    }
};

// Create membership
export const createMembership = (membershipData) => async dispatch => {
    if (localStorage.token) {
        setAuthToken(localStorage.token);
    }
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };
    try {
        const res = await axios.post(`${API_URL}/membership`, membershipData, config);
        if (res.data.success) {
            dispatch({
                type: CREATE_MEMBERSHIP,
                payload: res.data.data
            });
            dispatch(setAlert('Membership created successfully', 'success'));
            return res.data.data;
        } else {
            dispatch(setAlert(res.data.error, 'danger'));
            return null;
        }
    } catch (err) {
        dispatch(setAlert('Error: Failed to create membership', 'danger'));
        return null;
    }
};

// Update membership
export const updateMembership = (membershipData) => async dispatch => {
    if (localStorage.token) {
        setAuthToken(localStorage.token);
    }
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };
    try {
        const res = await axios.put(`${API_URL}/membership/${membershipData._id}`, membershipData, config);
        if (res.data.success) {
            dispatch({
                type: UPDATE_MEMBERSHIP,
                payload: res.data.data
            });
            dispatch(setAlert('Membership updated successfully', 'success'));
            return res.data.data;
        } else {
            dispatch(setAlert(res.data.error, 'danger'));
            return null;
        }
    } catch (err) {
        dispatch(setAlert('Error: Failed to update membership', 'danger'));
        return null;
    }
};

// Delete membership
export const deleteMembership = (membershipId) => async dispatch => {
    if (localStorage.token) {
        setAuthToken(localStorage.token);
    }
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };
    try {
        const res = await axios.delete(`${API_URL}/membership/${membershipId}`);
        if (res.data.success) {
            dispatch({
                type: DELETE_MEMBERSHIP,
                payload: membershipId
            });
            dispatch(setAlert('Membership deleted successfully', 'success'));
            // Refresh the memberships list
            dispatch(getMemberships());
        } else {
            dispatch(setAlert(res.data.error, 'danger'));
        }
    } catch (err) {
        dispatch(setAlert('Error: Failed to delete membership', 'danger'));
    }
}; 